/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SupportTicketTypeViewModel } from '../../models/support-ticket-type-view-model';

export interface GetSupportTicketTypes$Params {
}

export function GetSupportTicketTypes(http: HttpClient, rootUrl: string, params?: GetSupportTicketTypes$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SupportTicketTypeViewModel>>> {
  const rb = new RequestBuilder(rootUrl, GetSupportTicketTypes.PATH, 'get');
  if (params) {
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<SupportTicketTypeViewModel>>;
    })
  );
}

GetSupportTicketTypes.PATH = '/api/Tickets/GetSupportTicketTypes';
